export default __webpack_public_path__ + "fonts/980d5690197f126a9113336df888368b.woff";